import React from 'react';
import PublicArticleAdditionalInfoView from "../features/articles/views/public-article-additional-info-view";

const PublicArticleAdditionalInfoPage: React.FC = () => {
    return (
        <div className="w-full max-h-full">
            <div className="px-6 py-[40px] pb-[96px] max-w-[1800px] mx-auto">
                <PublicArticleAdditionalInfoView/>
            </div>
        </div>
    );
};

export default PublicArticleAdditionalInfoPage;


